/* eslint-disable max-lines */
import { PartnerRouteConfig } from "@gamedev-web/gamedev-sdk-core";

import { FaqPage } from "../pages/FaqPage";
import { LandingPage } from "../pages/LandingPage";
import { NewOrderPage } from "../pages/NewOrderPage";
import { OrderConfirmationPage } from "../pages/OrderConfirmationPage";
import { OrdersPage } from "../pages/OrdersPage";
import { CancelOrderPage } from "../pages/CancelOrderPage";
import { DevKitAssetsPage } from "../pages/DevKitAssetsPage";
import { VisualStudioAssetsPage } from "../pages/VisualStudioAssetsPage";
import { ShopPage } from "../pages/ShopPage";
import { CreateRmaPage } from "../pages/CreateRmaPage";
import { RmaReturnsPage } from "../pages/RmaReturnsPage";
import { RouteNames } from "./routeNames";

export enum Paths {
  IntroInfo = "intro-info",
  ApplicationIdPlaceholder = ":applicationId",
  PageIdPlaceholder = ":pageId",
  OrderNumberPlaceholder = ":orderNumber",
  OrderIdPlaceholder = ":orderId",
  AssetReturnIdPlaceholder = ":assetReturnId",
}

const routeGameDevBase = "/games";
const routeBase = `${routeGameDevBase}/partner/developer-store`;
export const DeveloperStoreUrls = {
  [RouteNames.Landing]: `${routeBase}/`,
  [RouteNames.NewOrder]: `${routeBase}/new-order`,
  [RouteNames.Faq]: `${routeBase}/faq`,
  [RouteNames.Shop]: `${routeBase}/shop`,
  [RouteNames.Orders]: `${routeBase}/orders`,
  [RouteNames.CancelOrder]: `${routeBase}/orders/cancel`,
  [RouteNames.OrderDetail]: `${routeBase}/orders/${Paths.OrderIdPlaceholder}`,
  [RouteNames.OrderConfirmation]: `${routeBase}/order-confirmation/${Paths.OrderNumberPlaceholder}`,
  [RouteNames.DevKitAssets]: `${routeBase}/devkit-assets`,
  [RouteNames.VisualStudioAssets]: `${routeBase}/visual-studio-assets`,
  [RouteNames.Rma]: `${routeBase}/rma`,
  [RouteNames.RmaDetail]: `${routeBase}/rma/${Paths.AssetReturnIdPlaceholder}`,
  [RouteNames.CreateRma]: `${routeBase}/rma/create`,
};

export const buildOrderConfirmationUrl = (
  orderGuid: string,
  orderId: string,
  simulated = false
) => {
  const query = new URLSearchParams({ orderId });
  if (simulated) {
    query.set("simulated", "true");
  }
  return `${routeBase}/order-confirmation/${encodeURIComponent(orderGuid)}?${query.toString()}`;
};
export const buildOrderDetailUrl = (orderId: string) =>
  `${routeBase}/orders/${encodeURIComponent(orderId)}`;
export const buildRmaReturnDetailUrl = (assetReturnId: number) =>
  `${routeBase}/rma/${encodeURIComponent(String(assetReturnId))}`;

export const developerStoreRouteConstraint = {
  featureGates: {
    enabletestconsole: (value: unknown) => value === true,
  },
};

export const developerStoreRmaRouteConstraint = {
  featureGates: {
    ...developerStoreRouteConstraint.featureGates,
    developerstorerma: (value: unknown) => value === true,
  },
};

export const routes: PartnerRouteConfig[] = [
  {
    key: RouteNames.Landing,
    path: DeveloperStoreUrls[RouteNames.Landing],
    component: LandingPage,
    exact: true,
    constraint: developerStoreRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.NewOrder,
    path: DeveloperStoreUrls[RouteNames.NewOrder],
    component: NewOrderPage,
    exact: true,
    constraint: developerStoreRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.Faq,
    path: DeveloperStoreUrls[RouteNames.Faq],
    component: FaqPage,
    exact: true,
    constraint: developerStoreRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.Shop,
    path: DeveloperStoreUrls[RouteNames.Shop],
    component: ShopPage,
    exact: true,
    constraint: developerStoreRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.Orders,
    path: DeveloperStoreUrls[RouteNames.Orders],
    component: OrdersPage,
    exact: true,
    constraint: developerStoreRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.CancelOrder,
    path: DeveloperStoreUrls[RouteNames.CancelOrder],
    component: CancelOrderPage,
    exact: true,
    constraint: developerStoreRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.OrderDetail,
    path: DeveloperStoreUrls[RouteNames.OrderDetail],
    component: OrdersPage, // TODO(jerry): change.
    exact: true,
    constraint: developerStoreRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.OrderConfirmation,
    path: DeveloperStoreUrls[RouteNames.OrderConfirmation],
    component: OrderConfirmationPage,
    exact: true,
    constraint: developerStoreRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.DevKitAssets,
    path: DeveloperStoreUrls[RouteNames.DevKitAssets],
    component: DevKitAssetsPage,
    exact: true,
    constraint: developerStoreRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.VisualStudioAssets,
    path: DeveloperStoreUrls[RouteNames.VisualStudioAssets],
    component: VisualStudioAssetsPage,
    exact: true,
    constraint: developerStoreRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.Rma,
    path: DeveloperStoreUrls[RouteNames.Rma],
    component: RmaReturnsPage,
    exact: true,
    constraint: developerStoreRmaRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.CreateRma,
    path: DeveloperStoreUrls[RouteNames.CreateRma],
    component: CreateRmaPage,
    exact: true,
    constraint: developerStoreRmaRouteConstraint,
    uhfConfig: { dark: true },
  },
  {
    key: RouteNames.RmaDetail,
    path: DeveloperStoreUrls[RouteNames.RmaDetail],
    component: RmaReturnsPage,
    exact: true,
    constraint: developerStoreRmaRouteConstraint,
    uhfConfig: { dark: true },
  },
];
